import HttpClient from '@/utility/http-client';

export default {
    getList(page: number, rowPerPage: number, filters: any[], quickFilters: any[], noname = 0) {
        const filter = filters && filters.length > 0 ? Buffer.from(JSON.stringify({ filter: filters })).toString('base64') : '';
        const quickFilter = quickFilters && quickFilters.length > 0 ? Buffer.from(JSON.stringify({ filter: quickFilters })).toString('base64') : '';
        const url = `/api/transition/?filter=${filter}&page=${page}&rowsPerPage=${rowPerPage}&q=${quickFilter}&noname=${noname}`;
        return HttpClient.instance().get(url);
    },
};
